import React from "react";

export const NichtGefunden: React.FC = () => {
  return (
    <div>
      <p>
        Bei der Eingabe Ihrer Sendungsnummer erhalten Sie die Meldung 
        „Für die Sendungsnummer konnte kein Zustellstatus gefunden werden.“ 
        Dies kann unterschiedliche Ursachen haben:
      </p>
      <p>
        <strong>Die Sendungsart ist nicht nachverfolgbar</strong>
      </p>
      <p>
        Aktuell können bei der PIN AG <br/><br/>
        -	Einschreiben<br/>
        -	Postzustellaufträge<br/> 
        -	Amazon Prime Sendungen<br/>
      </p>
      <p>
        Sicher bis zum Empfänger nachverfolgt werden. 
        Alle anderen Briefe sind Standardsendungen, bei denen es vom Absender nicht gewünscht wurde, 
        dass der Sendungsstatus ausgewiesen wird.  
      </p>
      <p>
        Weitere Informationen entnehmen Sie bitte dem Artikel 
        „Welche Sendungen kann ich nachverfolgen“?
      </p>
      <p>
        <strong>Die Sendungsnummer ist fehlerhaft oder ungültig</strong>
      </p>
      <p>
        Achten Sie bitte darauf, dass Sie bei Einschreiben oder Postzustellaufträgen die 
        Sendungsnummer ohne Klammerzeichen eingeben, also 0123456789108 statt 012345678910(8). 
      </p>
      <p>
        Grundsätzlich kann nur ein Ergebnis angezeigt werden, 
        wenn die Sendungsnummer korrekt und vollständig eingegeben wurde.
      </p>
      <p>
        <strong>Die Sendung ist zu alt</strong>
      </p>
      <p>
        Aus datenschutzrechtlichen Gründen ist die PIN AG dazu verpflichtet, 
        Sendungsdaten nach 6 Monaten zu löschen. Daher kann für Sendungen, 
        die älter als 6 Monate sind, der Sendungsstatus nicht mehr ausgewiesen werden.  
      </p>
    </div>
  );
};
